import React, { useEffect, useState } from 'react'
import './AudioVideoDiagnostics.css'
import { useAudioTest, useConnectivityTest, useVideoTest } from '../../../hooks'
import SemiCircularBar from '../../common/ProgressBar/SemiCircularBar/SemiCircularBar'
import { Button } from 'antd'
import ReactLoading from 'react-loading'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import { useDispatch, useSelector } from 'react-redux'
import config from '../../../config.json'
import $t from '../../../i18n'
import { average } from '../../../utils/calculationUtil'

export default function AudioVideoDiagnostics() {
  const {
    audioInputReport,
    audioOutputReport,
    setAudioInputReport,
    setAudioOutputReport,
    testAudioInput,
    testAudioOutput,
  } = useAudioTest()
  const { videoInputReport, setVideoReport, testVideoInput } = useVideoTest()
  const { connectivityReport, setConnectivityReport, testConnectivity } =
    useConnectivityTest()
  const [audioError, setAudioError] = useState(false)
  const [videoError, setVideoError] = useState(false)
  const [connectivityError, setConnectivityError] = useState(false)
  const [loader, setLoader] = useState(false)
  const [testCounter, setTestCounter] = useState(0)
  const { twilioToken } = useSelector(state => state.app)
  const dispatch = useDispatch()

  const connectivityDiagnostics = async () => {
    testAudioInput()
    testAudioOutput()
    testVideoInput()
    // testConnectivity()
  }

  useEffect(() => {
    dispatch(Actions.createAction(Actions.TWILIO_TOKEN_REQUESTED))
  }, [])

  useEffect(() => {
    setLoader(true)
    connectivityDiagnostics()
  }, [testCounter])

  useEffect(() => {
    if (twilioToken) {
      testConnectivity(twilioToken)
    }
  }, [twilioToken, testCounter])
  useEffect(() => {
    if (
      videoInputReport &&
      audioInputReport &&
      audioOutputReport &&
      connectivityReport
    ) {
      setLoader(false)
      if (
        audioInputReport?.errors?.length ||
        audioOutputReport?.errors?.length
      ) {
        setAudioError(true)
      } else {
        let audioAvg = average(audioInputReport?.values)
        if (audioAvg === 0) {
          setAudioError(true)
        }
      }

      if (videoInputReport?.errors?.length) {
        setVideoError(true)
      }

      if (connectivityReport?.progressEvents?.length < 7) {
        setConnectivityError(true)
      }
    }
  }, [
    audioOutputReport,
    audioInputReport,
    videoInputReport,
    connectivityReport,
  ])
  const handleRunAgain = () => {
    setTestCounter(prev => prev + 1)
    setAudioInputReport(null)
    setAudioOutputReport(null)
    setAudioError(false)
    setVideoError(false)
    setVideoReport(null)
    setConnectivityReport(null)
    setConnectivityError(false)
  }
  const handleBackToHomepage = () => {
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
    dispatch(Actions.createAction(Actions.END_CONNECTIVITY_TEST))
  }
  const handleContinue = () => {
    dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
    dispatch(Actions.createAction(Actions.END_CONNECTIVITY_TEST))
  }
  const handleContactSupport = () => {
    dispatch(Actions.createAction(Actions.END_CONNECTIVITY_TEST))
    dispatch(Actions.createAction(Actions.SUPPORT_CLICK))
  }
  const checkFailedTests = (audio, video, connectivity) => {
    if (audio && video && connectivity) {
      return $t('connectivityDiagnostics.audioVideoAndConnectivity')
    } else if (audio && video) {
      return $t('connectivityDiagnostics.audioAndVideo')
    } else if (audio && connectivity) {
      return $t('connectivityDiagnostics.audioAndConnectivity')
    } else if (video && connectivity) {
      return $t('connectivityDiagnostics.videoAndConnectivity')
    } else if (audio) {
      return $t('connectivityDiagnostics.yourAudio')
    } else if (video) {
      return $t('connectivityDiagnostics.yourVideo')
    } else if (connectivity) {
      return $t('connectivityDiagnostics.yourConnectivity')
    }
  }
  const barTitle = title => {
    if (title === 'Connectivity') {
      return $t('connectivityDiagnostics.connectivity')
    } else if (title === 'Video') {
      return $t('connectivityDiagnostics.video')
    } else if (title === 'Sound') {
      return $t('connectivityDiagnostics.sound')
    }
    return title
  }

  return (
    <div>
      {!loader ? (
        <>
          <div className="progress-indicator-container">
            <SemiCircularBar
              title={barTitle('Connectivity')}
              status={connectivityError ? 'Failed' : 'Passed'}
              statusName={
                audioError
                  ? $t('connectivityDiagnostics.failed')
                  : $t('connectivityDiagnostics.passed')
              }
            ></SemiCircularBar>
            <SemiCircularBar
              title={barTitle('Video')}
              status={videoError ? 'Failed' : 'Passed'}
              statusName={
                audioError
                  ? $t('connectivityDiagnostics.failed')
                  : $t('connectivityDiagnostics.passed')
              }
            ></SemiCircularBar>
            <SemiCircularBar
              title={barTitle('Sound')}
              status={audioError ? 'Failed' : 'Passed'}
              statusName={
                audioError
                  ? $t('connectivityDiagnostics.failed')
                  : $t('connectivityDiagnostics.passed')
              }
            ></SemiCircularBar>
          </div>
          <div className="connectivity-actions-container">
            {videoError || audioError || connectivityError ? (
              <>
                <div className="recommendation-text">
                  {testCounter === 1
                    ? checkFailedTests(
                        audioError,
                        videoError,
                        connectivityError
                      ) +
                      ' ' +
                      $t('connectivityDiagnostics.failedConnection')
                    : checkFailedTests(
                        audioError,
                        videoError,
                        connectivityError
                      ) +
                      ' ' +
                      $t('connectivityDiagnostics.recommendationText')}
                </div>
                <Button
                  type="primary"
                  className="runagain-btn"
                  onClick={testCounter === 1 ? handleContinue : handleRunAgain}
                >
                  {testCounter === 1
                    ? $t('connectivityDiagnostics.continue')
                    : $t('connectivityDiagnostics.runAgain')}
                </Button>
                <Button
                  type="secondary"
                  className="homepage-btn"
                  onClick={
                    testCounter === 1
                      ? handleContactSupport
                      : handleBackToHomepage
                  }
                >
                  {testCounter === 1
                    ? $t('connectivityDiagnostics.contactSupport')
                    : $t('connectivityDiagnostics.backToHome')}
                </Button>
              </>
            ) : (
              <Button
                type="primary"
                className="runagain-btn"
                onClick={handleContinue}
              >
                {$t('connectivityDiagnostics.continue')}
              </Button>
            )}
            <div
              className="troubleshoot-text"
              onClick={() =>
                dispatch(
                  Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
                    eventName: 'how_to_troubleshoot_ web',
                  })
                )
              }
            >
              <a href={config.troubleShootUrl} target="_blank">
                {$t('connectivityDiagnostics.troubleShoot')}
              </a>
            </div>
          </div>
        </>
      ) : (
        <div className="loading-wrapper">
          <div className="loading-text">
            {$t('connectivityDiagnostics.runningTests')}
          </div>
          <ReactLoading
            type={'spinningBubbles'}
            color={'var(--connectivityLoaderColor)'}
            height={'300px'}
            width={'150px'}
          ></ReactLoading>
        </div>
      )}
    </div>
  )
}
